module.exports = __webpack_public_path__ + "static/media/blender.e8a0299a.svg";